module.exports = __webpack_public_path__ + "static/media/close.97b1b8e1.png";